import styled from '@emotion/styled';
import React from 'react';
import { colorBlue, colorGreen, baseFont } from 'styles/base';
import HomePageCard from 'components/page/pcm-home/HomePageCard';
import logoImage from 'images/ARM_Logo2.png';
import bannerImage from 'images/ADI-Cover-Art.png';

const dodUrl = process.env.REACT_APP_DOD_URL; // injected by Node.js build environment parameters
const processUrl = `${process.env.REACT_APP_WINDOW_URL}/processes`; // injected by Node.js build environment parameters
const searchUrl = `${process.env.REACT_APP_WINDOW_URL}/search`; // injected by Node.js build environment parameters

const PageContent = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  height: 100%;
  overflow: auto;
`;

const TopContent = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${colorBlue};
  height: 242px;
  flex-shrink: 0;
`;

const FooterWrapper = styled('div')`
   display: flex;
   flex-direction: column;
   justify-content: flex-end;
   height: 100%;
   width: 1000px;
   flex: 1;
`;
const Footer = styled('div')`
   height: 28px;
   width: 1000px;
`;

const Title = styled('div')`
  display: flex;
  align-items: center;
  width: 1000px;
  color: white;
  font-weight: 700;
  font-size: 34px;
  height: 76px;
  ${baseFont}
`;

const Logo = styled.img`
   margin: 15px 19px 5px 43px;
   max-width: 151px;
`;

const ImageBanner = styled.div`
  position: relative;
  display: inline-block;
  background-color: white;
  height: 138px;
  width: 1000px;
`;

const Image = styled.img`
    width: 506px;
    position: absolute;
    right: 49px;
    top: 0;
`;

const ImageText = styled.p`
    position: absolute;
    left: 5%;
    top: 13%;
    width: 370px;
    font-size: 13px;
`;

const Capabilities = styled.div`
  display: flex;
  align-items: center;
  margin: 34px 0;
`;

const Cards = styled.div`
  display: flex;
  flex-direction: column;
`;

const HorizontalDivider = styled.div`
  width: 0;
  background: ${colorGreen};
  height: 240px;
  margin: 0 15px;
`;

export default class PCMHome extends React.Component {
   render() {
      document.title = 'PCM';
      return (
         <PageContent>
            <TopContent>
               <Title>
                  <Logo src={logoImage} alt="PCM" />
                  Processing Configuration Manager (PCM)
               </Title>

               <ImageBanner>
                  <ImageText>
                     PCM provides tools to manage <strong>process (Ingest/VAP)</strong> and <strong>DOD definitions </strong>
                     needed to run the <strong>ARM Data Integrator(ADI)</strong>.  ADI provides a pipeline to integrate
                     and transform multiple diverse datastreams into files that meet ARM file format and metadata standards.
                  </ImageText>
                  <Image src={bannerImage} alt="ADI" />
               </ImageBanner>
            </TopContent>
            <Capabilities>
                  <Cards>
                     <HomePageCard
                        link={processUrl}
                        iconClass="fa-cogs"
                        title="Manage Process Definitions"
                        description="Create or edit ADI process definitions and run your process with the data consolidator."
                        primary
                     />
                     <HomePageCard
                        link="https://engineering.arm.gov/ADI_doc/"
                        iconClass="fa-info"
                        title="Learn More About ADI"
                        description="Find out more about the ARM Data Integrator and how to write custom code for your process."
                     />
                     <HomePageCard
                        link={searchUrl}
                        iconClass="fa-search"
                        title="Search code.arm.gov"
                        description="Perform a full-text search through all ADI, VAP, or Ingest code in code.arm.gov."
                     />
                  </Cards>
                  <HorizontalDivider/>
                  <Cards>
                     <HomePageCard
                        link={dodUrl}
                        iconClass="fa-files-o"
                        title="Manage DODs"
                        description="Create, edit, or review data object definitions used to specify datastream file formats."
                        primary
                     />
                     <HomePageCard
                        link="https://www.arm.gov/publications/programdocs/doe-sc-arm-15-004.pdf"
                        iconClass="fa-calendar-check-o"
                        title="Read ARM Data Standards"
                        description="Read the full specifications for ARM data standards."
                     />
                     <HomePageCard
                        link="https://adc.arm.gov/MetadataService"
                        iconClass="fa-tags"
                        title="Manage Metadata"
                        description="Visit the Metadata Service to create or edit metadata for datastreams."
                     />
                  </Cards>

            </Capabilities>
            <FooterWrapper><Footer/></FooterWrapper>
         </PageContent>
      );
   }
}



// WEBPACK FOOTER //
// ./src/components/page/pcm-home/PCMHome.js